import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * An icon for Delete
 *
 * @author Praveen Punniyamoorthi
 */
const Delete = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d={`
    M13,0 C14.1045695,0 15,0.8954305 15,2 L22,2 C22.5522847,2 23,2.44771525 23,3 C23,3.55228475 22.5522847,4
    22,4 L21,4 L21,21 C21,22.6568542 19.6568542,24 18,24 L6,24 C4.34314575,24 3,22.6568542 3,21 L3,4 L2,4 C1.44771525,4 1,3.55228475 1,3
    C1,2.44771525 1.44771525,2 2,2 L9,2 C9,0.8954305 9.8954305,0 11,0 L13,0 Z M19,4 L5,4 L5,20.7777778 C5,21.4527925 5.44771525,22 6,22
    L18,22 C18.5522847,22 19,21.4527925 19,20.7777778 L19,4 Z M9,6 L9,19 C9,19.5522847 8.55228475,20 8,20 C7.44771525,20 7,19.5522847 7,19 L7,6
    L9,6 Z M17,6 L17,19 C17,19.5522847 16.5522847,20 16,20 C15.4477153,20 15,19.5522847 15,19 L15,6 L17,6 Z M13,6 L13,19 C13,19.5522847 12.5522847,20 12,20
    C11.4477153,20 11,19.5522847 11,19 L11,6 L13,6 Z`}
      fill="currentColor"
    />

  </SvgIcon>
);

export default Delete;
